import { InjectionToken } from '@angular/core';
import type { AppEnvironment } from '../environment/app-environment';

export const ENVIRONMENT = new InjectionToken<AppEnvironment>('APP_ENVIRONMENT');
